import http from '../../../../../lib/http'
import { notify } from '../../../../../lib/Notification/actions.js'
import { compartmentReceive } from '../../../patientActions.js'

export const ESAS = 'ESAS'
export const ESAS_SUCCESS = 'ESAS_SUCCESS'
export const ESAS_FAILURE = 'ESAS_FAILURE'

export const ESAS_BANNER = 'ESAS_BANNER'
export const ESAS_BANNER_SUCCESS = 'ESAS_BANNER_SUCCESS'
export const ESAS_BANNER_FAILURE = 'ESAS_BANNER_FAILURE'

function success (data) {
  return {
    type: ESAS_SUCCESS,
    data
  }
}

function failure (error) {
  return {
    type: ESAS_FAILURE,
    error
  }
}

function successBanner (data) {
  return {
    type: ESAS_BANNER_SUCCESS,
    data
  }
}

function failureBanner (error) {
  return {
    type: ESAS_BANNER_FAILURE,
    error
  }
}

export const getESAS = (patientId, encounterId) => dispatch => {
  dispatch({ type: ESAS })

  return http
    .getRequest(`/patients/${patientId}/esas?encounterId=${encounterId}`)
    .then(data => {
      dispatch(success(data))
    })
    .catch(err => dispatch(failure(err)))
}

export const getESASBanner = (patientId, clientName) => (dispatch, getState) => {
  let state = getState()
  clientName = clientName ?? state.globalVars?.params?.clientName

  if (!patientId || !clientName) {
    return null
  }

  dispatch({ type: ESAS_BANNER })

  return http
    .getRequest(`/patients/${patientId}/esasBanner`, {}, { clientName })
    .then(data => {
      dispatch(successBanner(data))
    })
    .catch(err => {
      dispatch(failureBanner(err))
    })
}

export const updateESAS =
  (formData, patientId, encounterId, notifyTitle) => dispatch => {
    dispatch(notify(`Updating ${notifyTitle}.`, false))

    return http
      .postRequest(
        `/patients/${patientId}/esas?encounterId=${encounterId}`,
        formData
      )
      .then(data => {
        dispatch(success(data))
        dispatch(notify(`Updated ${notifyTitle} successfully.`, false))
        dispatch(compartmentReceive(patientId))
        dispatch(getESASBanner(patientId))
      })
      .catch(err => {
        dispatch(notify(`Error updating ${notifyTitle}.`, true))
        dispatch(failure(err))
      })
  }
